import { useAppSelector } from "../../app/hooks";
import { selectHotel } from "../../features/hotel/hotelSlice";
import { selectBooking } from "../../features/booking/bookingSlice";
import { formatHotelAddress } from "../../helpers/hotels";
import { useTranslation } from "react-i18next";

export default function SummaryCard({ booking }: { booking: ReturnType<typeof selectBooking> }) {
  const hotel = useAppSelector(selectHotel);
  const { t } = useTranslation();

  return (
    <div className="bg-custom-100 rounded-xl text-black text-fluid-base flex flex-col w-full p-4 gap-2">
      <div className="text-h4">{hotel.Name[hotel.Culture.LanguageCode] || hotel.Name["en-US"]}</div>
      <div className="text-gray-700">
        {formatHotelAddress(hotel.Address)}
        <br />
        {booking.NightCount} {t("scenes.night", { count: booking.NightCount })}
        {", "}
        {booking.PeopleCount}{" "}
        {t("scenes.traveller", { count: booking.PeopleCount })}
      </div>
    </div>
  );
}
